import { Injectable } from '@angular/core';
import { ConfigService } from '../../config.service';
import { ConfigDataStoreService } from './config-data-store.service';
import { UserService } from '../../../shared/services/user.service';
import { SystemConfigDTO } from '../../../shared/dto/system-config/system-config-dto';
import { PatentType } from '../../../shared/dto/system-config/patent-type';
import { SystemConfigResponseDTO } from '../../../shared/dto/system-config/system-config-response-dto';

@Injectable()
export class PatentTypeDataStoreService extends ConfigDataStoreService<PatentType> {

  constructor(configService: ConfigService, userService: UserService) {
    super(configService, userService, 'PATENT_TYPE');
  }

  public create(data: PatentType): Promise<SystemConfigResponseDTO> {
    const configObject: SystemConfigDTO = { userId: this.user.id, type: this.type, patentTypeConfigDTO: data };
    const response = this.configService.addSystemConfig(configObject);
    response.then(res => {
      this.dataSetPromise.then(dataSet => {
        dataSet.push(res.configValueDTO as PatentType);
        this.dataSet.next(dataSet);
        this.dataSetPromise = Promise.resolve(dataSet);
      });
    });

    return response;
  }

  public update(data: PatentType): Promise<SystemConfigResponseDTO> {
    const configObject: SystemConfigDTO = { userId: this.user.id, type: this.type, patentTypeConfigDTO: data };
    const response = this.configService.updateSystemConfig(configObject);
    response.then(res => {
      this.dataSetPromise.then(dataSet => {
        const index = dataSet.findIndex(dataPoint => dataPoint.id === res.configValueDTO.id);
        dataSet[index] = res.configValueDTO as PatentType;
        this.dataSet.next(dataSet);
        this.dataSetPromise = Promise.resolve(dataSet);
      });
    });

    return response;
  }

  public enable(data: PatentType): Promise<SystemConfigResponseDTO> {
    return this.configService.updateSystemConfig({ userId: this.user.id, type: this.type, patentTypeConfigDTO: data });
  }

  public disable(data: PatentType): Promise<SystemConfigResponseDTO> {
    return this.configService.updateSystemConfig({ userId: this.user.id, type: this.type, patentTypeConfigDTO: data });
  }
}
